/**
 * How agents should work a project's tickets (TOADO-998): one text the team writes on
 * Board workflow, saved with who saved it and when. get_ticket_brief hands it to an agent
 * as `teamInstructions`, so nobody copies it and an agent always reads the latest.
 */
export interface AgentInstructions {
  text: string;
  updatedAt: string;
  /** Null when the person who saved it is gone. */
  updatedBy: { id: string; name: string } | null;
}

/** The most characters the instructions hold, checked by the API and counted on the page. */
export const AGENT_INSTRUCTIONS_MAX_CHARS = 4000;
